import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  getRoomFormattedDescriptionBody,
  joinRoomTypeAndBeds,
  removeCommissionTerms,
} from '../../../../helpers/formatters/formatRoomDescription';

const RoomRateDescription = ({
  room,
  doShowRawGDSDescription,
  doShowOriginalShorterRoomDescription,
  doShowAgentCommission,
  doEmphasizeRoomTitle,
}) => {
  if (!room) return <></>;
  const category =
    doShowAgentCommission || !(room.category || '').toLowerCase().includes('commission')
      ? room.category
      : undefined;

  const descriptionBody = doShowAgentCommission ? room.desc : removeCommissionTerms(room.desc);

  const hasTypeOrBeds = !!(room.type || (room.bedTypes && room.bedTypes.length > 0));
  const typeBedsTitle = joinRoomTypeAndBeds(room);
  /** When no room type/beds, show category as the primary title (deduped from the lower category row). */
  const primaryTitle = hasTypeOrBeds ? typeBedsTitle : category;
  const showCategoryBelow = !!(category && hasTypeOrBeds);
  const titleEmphasisClass = doEmphasizeRoomTitle && 'font-bold text-lg text-gray-900 leading-snug';
  const flatSecondaryDesc = 'text-sm text-gray-600 leading-relaxed';

  const rawGdsHasTitleRow = !!(hasTypeOrBeds || category);
  const rawGdsTitleText = hasTypeOrBeds ? typeBedsTitle : category;
  const rawGdsSecondaryText =
    hasTypeOrBeds && category ? `${category} - ${descriptionBody}` : descriptionBody;

  return (
    <div className="flex flex-col">
      {doShowRawGDSDescription && (
        <>
          {rawGdsHasTitleRow && <div className={clsx(titleEmphasisClass)}>{rawGdsTitleText}</div>}
          <div className={clsx(flatSecondaryDesc, rawGdsHasTitleRow && 'mt-1')}>
            {rawGdsSecondaryText}
          </div>
        </>
      )}
      {!doShowRawGDSDescription && (
        <>
          {doShowOriginalShorterRoomDescription ? (
            <>
              {primaryTitle && <div className={clsx(titleEmphasisClass)}>{primaryTitle}</div>}
              <div className={clsx(flatSecondaryDesc, primaryTitle && 'mt-1')}>
                {getRoomFormattedDescriptionBody(room, doShowAgentCommission)}
              </div>
            </>
          ) : (
            primaryTitle && <div className={clsx(titleEmphasisClass)}>{primaryTitle}</div>
          )}
          {showCategoryBelow && <div className="text-md text-gray-600">{category}</div>}
        </>
      )}
    </div>
  );
};

RoomRateDescription.propTypes = {
  room: PropTypes.shape({
    category: PropTypes.string,
    desc: PropTypes.string.isRequired,
    originalDesc: PropTypes.string,
    formattedDesc: PropTypes.string,
    originalFormattedDesc: PropTypes.string,
    type: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape()),
    bedTypes: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  doShowRawGDSDescription: PropTypes.bool,
  doShowOriginalShorterRoomDescription: PropTypes.bool,
  doShowAgentCommission: PropTypes.bool,
  doEmphasizeRoomTitle: PropTypes.bool,
};

RoomRateDescription.defaultProps = {
  doShowRawGDSDescription: true,
  doShowOriginalShorterRoomDescription: false,
  doShowAgentCommission: true,
  doEmphasizeRoomTitle: false,
};

export default RoomRateDescription;
